import { jsx as _jsx } from "react/jsx-runtime";
import { PastedTextFileNotes } from '#pplx/frontend/apps/ask/composer-ui/PastedTextFileNotes.js';
import { useComposerEditor } from '#pplx/frontend/composer-sdk/ComposerEditorContext.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useEffect, useState } from 'react';
const pasteConversionActionEvent = EVENT_PAYLOAD;
export function ComposerPastedTextFileNotice({ characterLimit, convertedFile, disabled, files, inputLength, onDismissConversion, onRemoveFile, }) {
    const editor = useComposerEditor();
    const { track } = useInstrumentation();
    const [convertedTextFile, setConvertedTextFile] = useState(null);
    const [showTrimmedPasteNote, setShowTrimmedPasteNote] = useState(false);
    const uploadId = files.find(({ file }) => file === convertedFile)?.id;
    useEffect(() => {
        // No tracked upload means the existing quota or file-selection gate declined the paste.
        if (convertedFile === null || uploadId === undefined)
            return;
        let canceled = false;
        void convertedFile.text().then((content) => {
            if (!canceled)
                setConvertedTextFile({ file: convertedFile, content, uploadId });
        });
        return () => {
            canceled = true;
        };
    }, [convertedFile, uploadId]);
    const activeTextFile = convertedTextFile?.file === convertedFile ? convertedTextFile : null;
    const trackAction = (action) => track(pasteConversionActionEvent({
        name: 'query paste conversion action selected',
        data: { action },
    }));
    const pasteAsText = () => {
        if (disabled || activeTextFile === null)
            return;
        const remainingCharacters = Math.max(0, characterLimit - inputLength);
        const contentToPaste = activeTextFile.content.slice(0, remainingCharacters);
        if (contentToPaste.length > 0)
            editor.append(contentToPaste);
        setShowTrimmedPasteNote(contentToPaste.length < activeTextFile.content.length);
        // The upload owner's removal set also suppresses any later completion of a pending upload.
        onRemoveFile(activeTextFile.uploadId);
        onDismissConversion();
        trackAction('paste_as_text');
    };
    return (_jsx(PastedTextFileNotes, { characterLimit: characterLimit, convertedTextLength: activeTextFile?.content.length, disabled: disabled, showTrimmedPasteNote: showTrimmedPasteNote, onPasteAsText: pasteAsText, onDismissConversion: () => {
            onDismissConversion();
            trackAction('dismiss_conversion');
        }, onDismissTrimmed: () => {
            setShowTrimmedPasteNote(false);
            trackAction('dismiss_trimmed');
        } }));
}
//# sourceMappingURL=ComposerPastedTextFileNotice.js.map